/*
 * This file is part of the https://gitlab-intern.easd-support.de/easd/p26s26_energie_watchdog project.
 *
 * (c) 2026 EA Systems Dresden GmbH
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

export interface AddSensorTargetResult {
    targets: string[];
    wasAdded: boolean;
    wasDuplicate: boolean;
}

export function addSensorTarget(targets: string[], target: string): AddSensorTargetResult {
    const normalizedTarget = target.trim();

    if (!normalizedTarget) {
        return {
            targets,
            wasAdded: false,
            wasDuplicate: false,
        };
    }

    if (targets.includes(normalizedTarget)) {
        return {
            targets,
            wasAdded: false,
            wasDuplicate: true,
        };
    }

    return {
        targets: [...targets, normalizedTarget],
        wasAdded: true,
        wasDuplicate: false,
    };
}

export function removeSensorTarget(targets: string[], targetToRemove: string): string[] {
    return targets.filter((target) => target !== targetToRemove);
}
